/**
 * randomWord 产生任意长度随机字母数字组合
 * randomFlag-是否任意长度 min-任意长度最小位[固定位数] max-任意长度最大位
 **/
 export const randomWord = (randomFlag, min, max = 64) => {
  const arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j',
    'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G',
    'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
  let str = ''
  let range = min

  // 随机产生
  if (randomFlag) {
    range = Math.round(Math.random() * (max - min)) + min
  }
  for (let i = 0; i < range; i++) {
    const pos = Math.round(Math.random() * (arr.length - 1))
    str += arr[pos]
  }
  return str
}

/**
 * 随机生成UDID
 */
 export const randomUuid = () => {
  const str = []
  const hexDigits = '0123456789abcdef'
  for (let i = 0; i < 36; i++) {
    str[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
  }
  str[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010
  str[19] = hexDigits.substr((str[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
  str[8] = str[13] = str[18] = str[23] = '-'

  return str.join('')
}

/**
 * 获取浏览器系统信息
 */
 export const getDeviceInfo = () => {
  const {
    userAgent,
    language,
    platform,
  } = window.navigator
  const ua = userAgent.toLowerCase()
  const isIOS = /ipad|ipod|iphone/i.test(ua)
  const model = ua.split(/\s/)

  const osVerson = (ua.match(/.+(?:android|os)[/: ]([\d.|_]+)/) || [])[1]
  const productName = (ua.match(/.+(version|chrome|crios|ucbrowser|qq|micromessenger)[/: ]([\d.|_]+)/) || [])[1]
  const productVersion = (ua.match(/.+(?:version|chrome|crios|ucbrowser|qq|micromessenger)[/: ]([\d.|_]+)/) || [])[1]
  const modelId = isIOS ? (model[1] || '').replace(/\(|;/g, '') : model[4]

  if (window.FDMarketMeta) {
    const { OsVersion, UUID, Platform, AppVersion, AppName } = window.FDMarketMeta
    return JSON.stringify({
      model: modelId || '', // 终端标识
      platform: Platform || '', // 平台，可能取值Android、iPhone、iPad、Windows
      os_version: OsVersion || '', // 系统版本号
      device_id: UUID || '', // 设备唯一标识（供虚拟信息）
      product_name: AppName || '', // 产品标识
      product_version: AppVersion || '', // 产品版本
      locale: language // 地区
    })
  }

  return JSON.stringify({
    model: modelId || '', // 终端标识
    platform: platform || 'Android', // 平台，可能取值Android、iPhone、iPad、Windows
    os_version: (osVerson || '').replace(/_/g, '.'), // 系统版本号
    device_id: randomUuid(), // 设备唯一标识（供虚拟信息）
    product_name: productName, // 产品标识
    product_version: productVersion, // 产品版本
    locale: language // 地区
  })
}
